import _ from 'lodash';
import React, {Component} from 'react';
import {Field, reduxForm, getFormValues} from 'redux-form';
// import axios from 'axios';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import {withFirebase} from 'react-redux-firebase';
import Dropzone from 'react-dropzone';

import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
// core MUI components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
// import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import AddCircle from "@material-ui/icons/AddCircleOutline";
import RemoveCircle from "@material-ui/icons/RemoveCircleOutline";
import Poll from "@material-ui/icons/Poll";

import loginPageStyle from 'assets/jss/material-kit-react/views/loginPage.jsx';
import bark1080 from "assets/img/background/bark1080.jpg"

import {createPoll, uploadPicToS3} from '../actions';
import {CREATE_POLL_FIELDS} from './formFields';
import LoadingSpinner from 'utils/LoadingSpinner/';

const LAST_ANS_DEF_TXT = 'Other (discuss in the comments!)';
const MAX_IMG_SIZE = 1024 * 1024 * 3; //3MB
// TODO make a min img size??
// TODO check the img dimensions or scale it?

class CreatePollPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardAnimaton: "cardHidden",
      numberOfAns: 3,
      formFields: null,
      bgImg: bark1080,
      draggedFile: null,
      hasPreviewData: false,
      formsFilledInFromPreviousData: false,
    };
  }

  componentWillMount() {
    this.setState({formFields: CREATE_POLL_FIELDS});
    // if we have data passed back from the poll preview page
    if (this.props.location.state) {
      // console.log('previous data, we have?')
      const {fromPreviewData} = this.props.location.state;
      this.setState({
          hasPreviewData: true,
          bgImg: fromPreviewData.img.preview,
          draggedFile: fromPreviewData.img
        },
        this.initFormFromPreviewPageData(fromPreviewData)
      );
    }
    else {
      // NOTE init the default last answer to "Other"
      this.props.initialize({
        answer3: 'Other (discuss in the comments!)',
      });
    }
  }

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      500
    );
  }

  componentWillUnmount() {
    // TODO DEBUG FIXME need to implment this on the preview page??
    // pass revoke this file but create a new one to pass via state???

    const {bgImg, usingImgBlobPreviewPage} = this.state;
    // wait to revoke the url in the preview page, if we nav to there
    if (bgImg !== null && !usingImgBlobPreviewPage) {
      console.log('REVOKING IMG');
      window.URL.revokeObjectURL(bgImg);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkDraggedImgUpdate(prevState);
  }

  checkDraggedImgUpdate(prvState) {
    const {draggedFile} = this.state;
    const prvDrgFile = prvState.draggedFile;
    const userImgChange = (prvDrgFile !== draggedFile);
    if (userImgChange && draggedFile !== null) {
      // set new background img to the user uploaded one
      this.setState({bgImg: draggedFile.preview});
      // destroy the old user img preview! from the previoulsly uploaded pic, if there was one
      if (prvDrgFile !== null) {
        console.log('REVOKING IMG');
        window.URL.revokeObjectURL(prvDrgFile.preview);
      }
    }
  }

  initFormFromPreviewPageData(_previousData) {
    // NOTE first set the form data for ques & descrip
    let dataToInit = {
      question: _previousData.question,
      descrip: _previousData.descrip,
    }

    // NOTE we need to reformat the answer data before we init form with it
    _previousData.answers.forEach(ans => {
      const ansNum = ans.ans_id + 1;
      // NOTE by deafault we only have 3 answer fields on the form
      if (ansNum > 3) {
        this.addAnswerTextField(true);
      }
      // NOTE then set the value for each answer
      dataToInit[`answer${ansNum}`] = ans.answer;
    });

    this.props.initialize(dataToInit);
    this.setState({formsFilledInFromPreviousData: true});
  }

  // generatePicName(poll_question, old_name){
  //   // always will end with ".jpg" or ".png", so take the last item in array
  //   const file_ext = old_name.split(".").slice(-1)[0];
  //
  // }


  onFormSubmit(values) {
    // this.setState({uploading: true});
    const {question, descrip, ...answers} = values;
    const {bgImg, draggedFile} = this.state;
    const {uploadPicToS3, auth, createPoll, history} = this.props;

    const sorted_answers = _(answers).toPairs().sortBy(0).fromPairs().value();
    const answersWithFakeIDs = _.values(sorted_answers).map((ans, i) => {
      return {ans_id: i, answer: ans};
    });
    const previewData = {question, descrip, img: draggedFile, answers: answersWithFakeIDs};
    const navToPreviewPage = () => history.push({pathname: '/poll/preview', state: {previewData}});
    this.setState({usingImgBlobPreviewPage: true}, navToPreviewPage);

    // // NOTE TODO QUESTION generate filename for uploaded pic? this makes it harder to run embedded code from uploaded files
    // const newPicName = this.generatePicName(question, draggedFile.name);
  }

  addLastAnsFieldDefaultTxt(prevLastAnsNum, newLastAnsNum) {
    const {formVals} = this.props;
    const prevLastAnsTxt = formVals[`answer${prevLastAnsNum}`];
    // remove default txt, but do not change anything if user has edited it!
    const updatedPrevLasAnsTxt = (prevLastAnsTxt === LAST_ANS_DEF_TXT) ? '' : prevLastAnsTxt;
    this.props.initialize({
      ...formVals,
      [`answer${prevLastAnsNum}`]: updatedPrevLasAnsTxt,
      [`answer${newLastAnsNum}`]: LAST_ANS_DEF_TXT,
    });
  }

  removeLastAnsFieldDefaultTxt(newLastAnsNum) {
    const {formVals} = this.props;
    const prevLastAnsTxt = formVals[`answer${newLastAnsNum}`];
    // if new last field is empty, add default txt, if not empty, don't modify it!
    const updatedNewLasAnsTxt = (prevLastAnsTxt === '') ? LAST_ANS_DEF_TXT : prevLastAnsTxt;
    this.props.initialize({
      ...formVals,
      [`answer${newLastAnsNum}`]: updatedNewLasAnsTxt,
    });
  }

  addAnswerTextField (fromPreview=false) {
    const {formFields, numberOfAns} = this.state;
    const {formVals} = this.props;
    // TODO QUESTION have a max number of possible answers??
    if (numberOfAns < 10) {
      const newNumOfAns = numberOfAns + 1;
      const form = {
        label: `Answer ${newNumOfAns} `,
        inputType: 'text',
        iconType: Poll,
      }

      let fields = formFields;
      if (fromPreview) {
        // NOTE HACK it seems formFields is NOT set in state yet,
        // when we are loading data from the preview page.
        // we can just use the CREATE_POLL_FIELDS const, cause the vals dont actually matter
        // we are resetting (initializing) the form fields to data from preview page
        fields = {...CREATE_POLL_FIELDS}
      } else {
        this.addLastAnsFieldDefaultTxt(numberOfAns, newNumOfAns);
      }

      this.setState({
        formFields: {...fields, [`answer${newNumOfAns}`]: form},
        numberOfAns: newNumOfAns,
      });
    }
  }

  removeAnswerTextField = () => {
    const {formFields, numberOfAns} = this.state;
    // if not at least two answers, why vote?
    if (numberOfAns > 2) {
      const newNumOfAns = numberOfAns - 1;
      // return _.omit(state, action.payload);
      this.removeLastAnsFieldDefaultTxt(newNumOfAns);

      this.setState({
        formFields: _.omit(formFields, `answer${numberOfAns}`),
        numberOfAns: newNumOfAns,
      });
    }
  }

  // renderField(field) {
  //   const {meta: {touched, error}} = field;
  //   const className = `form-group ${touched && error ? 'has-danger' : ''}`;
  //
  //   return (
  //     <div className={className}>
  //       <label>{field.label}</label>
  //       <input className="form-control" type="text" {...field.input} />
  //       <div className="text-help">
  //         {touched ? error : ''}
  //       </div>
  //     </div>
  //   );
  // }

  renderTextField(field) {
    // QUESTION answers shouldn't be longer than 40 chars?
    let input_props = {maxLength: 40};
    if (field.input.name === 'question') {
      input_props = {maxLength: 100};
    } else if (field.input.name === 'descrip') {
      input_props = {maxLength: 300};
    }

    return (
      <TextField
        id={field.input.name}
        label={field.label}
        placeholder={field.placeholder}
        fullWidth
        required
        margin='normal' // 'none' | 'dense' | 'normal'
        InputProps={{
          type: field.inputType,
          endAdornment: (
            <InputAdornment position="end">
              <field.iconType className={field.iconClassName} />
            </InputAdornment>
          )
        }}
        // NOTE seems although its ignoring the case, need both.
        // eslint-disable-next-line
        inputProps={input_props}
        {...field.input}
        {...field.custom}
      />
    );
  }

  invalidFile(rejected) {
    // console.log('rej', rejected);
    if (rejected.length === 1) {
      if (rejected[0].size > MAX_IMG_SIZE) {
        window.confirm('The image cannot be larger than 3MB! Try again with a new picture.');
      } else {
        window.confirm(`${rejected[0].name} is not an image file! (*.jpeg or *.png) Try again.`);
      }
      console.log('REVOKING IMG');
      window.URL.revokeObjectURL(rejected[0].preview);
    } else if (rejected.length > 1) {
      window.confirm('Only can upload one image at a time!');
      // NOTE this should not be possible, but not sure if restriction is working properly
      console.log('REVOKING IMGS');
      rejected.forEach(userImg => window.URL.revokeObjectURL(userImg.preview));
    }
  }

  validFileDropped(accepted) {
    if (accepted.length === 1) {
      const draggedFile = accepted[0];
      // console.log("set image to:", draggedFile);
      this.setState({draggedFile});
    } else if (accepted.length > 1) {
      window.confirm('Try Again! ...Only one image');
      console.log('REVOKING IMGS');
      accepted.forEach(userImg => window.URL.revokeObjectURL(userImg.preview));
    }
  }

  renderDropZone() {
    const {draggedFile, hasPreviewData} = this.state;
    const {classes, aws, poll} = this.props;

    if (aws.loading || poll.creating) {
      return <LoadingSpinner />
    }

    const defTxt = "Click/Drag to upload a poll pic *";
    // let boxTxt = hasPreviewData ? this.props.location.state.fromPreviewData.imgFname : defTxt;
    // boxTxt = draggedFile === null ? boxTxt : `${draggedFile.name}`;
    const boxTxt = draggedFile === null ? defTxt : `${draggedFile.name}`;

    return (
      <div className="dropzone" >
        <Dropzone
          accept="image/jpeg, image/png"
          className={classes.dropZone}
          multiple={false}
          maxSize={MAX_IMG_SIZE}
          // disablePreview
          onDropAccepted={(accepted) => { this.validFileDropped(accepted) }}
          onDropRejected={(rejected) => { this.invalidFile(rejected) }}
        >
          { ({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
            return boxTxt;
          }}
        </Dropzone>
      </div>
    );
  }

  renderCardBody() {
    const {classes} = this.props;
    const {formFields, hasPreviewData, formsFilledInFromPreviousData} = this.state;

    if (hasPreviewData && !formsFilledInFromPreviousData) {
      return <LoadingSpinner />;
    }
    return (
      <CardBody>
        {this.renderDropZone()}
        {_.map(formFields, (field, fname) => {
          return (
            <Field
              label={field.label}
              placeholder={field.placeholder}
              name={fname}
              key={fname}
              inputType={field.inputType}
              iconType={field.iconType}
              iconClassName={classes.inputIconsColor}
              component={this.renderTextField}
            />
          );
        })}
      </CardBody>
    );
  }

  render() {
    const {classes, handleSubmit, auth, ...rest} = this.props;
    const {bgImg, draggedFile} = this.state;
    const createBtnEnabled = (draggedFile !== null);

    return (
      <div>
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + bgImg + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} md={8} lg={6}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))} className={classes.form}>
                    <CardHeader color="primary" className={classes.cardHeader}>
                      <h3>Create Poll</h3>
                    </CardHeader>
                    {this.renderCardBody()}
                    <CardFooter className={classes.cardFooter}>
                      <Button fullWidth disabled={!createBtnEnabled} style={{marginRight: 10}} color="primary" size="lg" type="submit">
                        Preview Poll
                      </Button>
                      <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={12}>
                          <Button size="sm" onClick={() => this.addAnswerTextField()} color="transparent" className={classes.addAnsBtns}>
                            <InputAdornment>
                              <AddCircle className={classes.inputIconsColor} />
                            </InputAdornment>
                            answer
                          </Button>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                          <Button size="sm" onClick={this.removeAnswerTextField} color="transparent" className={classes.addAnsBtns}>
                            <InputAdornment>
                              <RemoveCircle className={classes.inputIconsColor} />
                            </InputAdornment>
                            answer
                          </Button>
                        </GridItem>
                      </GridContainer>
                    </CardFooter>
                  </form>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.firebase.auth,
    formVals: getFormValues('createPollForm')(state),
    poll: state.poll,
    aws: state.aws,
  };
}

const pageWithFirebase = withStyles(loginPageStyle)(withFirebase(CreatePollPage));

export default reduxForm({
  form: 'createPollForm',
})(
  withRouter(connect(mapStateToProps, {createPoll, uploadPicToS3})(pageWithFirebase))
);



// WEBPACK FOOTER //
// ./src/views/CreatePoll.js